export default function ParseTime(time) {
    time = time.split("T")[1].replaceAll("-", " ").split(".")[0]
    return time.split(" ").join(".")
}